import { render, staticRenderFns } from "./MailIcon.vue?vue&type=template&id=23f192d4&scoped=true&"
import script from "./MailIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./MailIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f192d4",
  null
  
)

export default component.exports